import React, { useState } from 'react';
import { Selector } from '../common';
import { disciplineService } from './disciplineService';

function DisciplineSelector({
    onChange,
    ...props
}) {
    const [suggestions, setSuggestions] = useState(null);

    function handleSlectorInputChange(value) {
        disciplineService.indexDisciplines({
            sortOrder: null,
            searchString: value,
            pageSize: 10,
            pageNumber: 1
        })
        .then(response => setSuggestions(response.data.entities))
        .catch(error => console.error(error));
    }

    function handleSelectorValueChange(value) {
        onChange(value);
    }

    function formatDisciplineString(discipline) {
        return discipline?.discipline_name ?? '';
    }

    return (
        <Selector {...props} onInputChange={handleSlectorInputChange} onValueChange={handleSelectorValueChange} itemStringExtractor={formatDisciplineString} suggestedItems={suggestions}/>
    );
}

export default DisciplineSelector;